import React, { ReactNode } from 'react';
import {
  filter,
  first,
  map,
  Observable,
  publishReplay,
  refCount,
  switchMap,
} from 'rxjs';

import { connectedWalletChange$ } from '../../../../../api/wallet/connectedWalletChange';
import { PublicWhitelistForm } from './PublicWhitelistForm';

export const getSpectrumWhitelistForm = (): Observable<
  ReactNode | ReactNode[] | string
> =>
  connectedWalletChange$.pipe(
    filter(Boolean),
    switchMap((wallet) => wallet.getChangeAddress()),
    first(),
    map((address) => <PublicWhitelistForm address={address} />),
    publishReplay(1),
    refCount(),
  );
